import { createRouter, createWebHashHistory } from 'vue-router';
// import HomeView from '../views/HomeView.vue'
import StudentHome from '../components/StudentHome.vue';
import FacultyHome from '../components/Faculty/FacultyHome.vue';
import MaterialListing from '../components/MaterialListing.vue';
import CourseFinder from '../components/CourseFinder.vue';
import LoginComponent from '../components/LoginComponent.vue';
import NotFound from './../../src/NotFound.vue';
import NewBookForm from '../components/Faculty/NewBookSubmitForm.vue'
import store from '../store'
// function lazyLoad(view){
//   return() => import(`@/components/${view}.vue`)
// }


const routes = [
  {
    path: '/',
    name: 'home', 
    redirect: '/student/material-finder'
  },
  {
    path: '/student',
    name: 'Student',
    component: StudentHome,
    children: [
      {
        path: 'material-finder',
        name: 'NorthWest Supplemental Material Finder',
        component: CourseFinder
      },
      {
        path: 'material-listing',
        name: 'Supplemental Material Finder listing',
        component: MaterialListing
      }
    ]
  },
  {
    path: '/faculty-login',
    name: 'Faculty Login',
    component: LoginComponent
  },
  {
    path: '/faculty',
    name: 'Faculty',
    component: FacultyHome,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/new-book-submission/',
    name: 'NewBookSubmission',
    component: NewBookForm,
    props:true
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { path: "/:catchAll(.*)", component: NotFound }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  document.title = to.name;
  if (to.meta.requiresAuth) {
    if (!store.state.isLoggedIn && to.path !== '/faculty-login') {
      next({
        path: '/faculty-login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})


export default router
